<template>
  <div :class="$style.grid">
    <slot />
  </div>
</template>

<style module lang="scss">
.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: auto;
  gap: 0;

  margin-right: -1px;
  margin-bottom: -1px;
  overflow: hidden;
}

@media (min-width: 768px) and (max-width: 1379px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 480px) and (max-width: 767px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 479px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
</style>
